'use strict';

/* global $ */
/* global _ */

// import { scrollBody } from '../utils/params';

/**
 * Обработчк для фиксации шапки сайта
 * @param {Object} options хеш параметров.
 * Параметры:
 *     selector - элемент, в котором находится блок шапки, который нужно зафиксировать
 *     fixed - класс для фиксированной шапки
 *     compact - класс для компактного представления шапки
 *     mobile - признак вызываем на телефоне или нет
 */
function FixedHeader(options){
    let opt = _.extend({ }, { selector: '.js-header-fixed',
                              fixed: 'is-fixed',
                              compact: 'is-compact',
                              mobile: false }, options);
    // if(opt.mobile)
        // return;

    let $wrap = $(opt.selector);
    let headerHeight = 0;
    let defaultPadding = 0;
    let headerPosition = 0;
    let screenWidth = 0;

    if($wrap.length) {
        // detectScreenParams();

        $(window).on('scroll', onScroll)
                 .on('resize', detectScreenParams)
                 .on('reposition', onReposition)
                 .trigger('reposition');

    }

    function onReposition(){
        $(window).trigger('resize');
    }

    function detectScreenParams(){
        var width = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;
        screenWidth = width;

        headerHeight = $wrap.outerHeight();
        let position = $wrap.parent().offset();
        headerPosition = position.top;
        $wrap.parent().css('paddingTop', '');
        defaultPadding = $wrap.parent().css('paddingTop');
        $(window).trigger('scroll');
    }

    function onScroll(){
        let add = false;
        if(window.pageYOffset > headerHeight + headerPosition){
            add = true;
        }
        changeCompact(add);
        changeFixed(add);
    }

    function changeCompact(add){
        if(add){
            if(screenWidth > 999){
                if(!$wrap.parent().hasClass(opt.compact)){
                    $wrap.parent().css('paddingTop', headerHeight);
                    $wrap.parent().addClass(opt.compact);
                }
            }else{
                if($wrap.parent().hasClass(opt.compact)){
                    $wrap.parent().css('paddingTop', defaultPadding);
                    $wrap.parent().removeClass(opt.compact);
                }
            }
        }else{
            if($wrap.parent().hasClass(opt.compact)){
                $wrap.parent().css('paddingTop', defaultPadding);
                $wrap.parent().removeClass(opt.compact);
            }
        }
    }

    function changeFixed(add){
        if(add){
            $wrap.addClass(opt.fixed);
        }else{
            $wrap.removeClass(opt.fixed);
        }
    }

}

export {
    FixedHeader
};